import { Carousel, ConfigProvider } from 'antd';
import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import history1 from '@/../../public/ourhistory/ourhistory_1.webp';
import history2 from '@/../../public/ourhistory/ourhistory_2.webp';
import history3 from '@/../../public/ourhistory/ourhistory_3.webp';
import history4 from '@/../../public/ourhistory/ourhistory_4.webp';
import history5 from '@/../../public/ourhistory/ourhistory_5.webp';
import history6 from '@/../../public/ourhistory/ourhistory_6.webp';
import history7 from '@/../../public/ourhistory/ourhistory_7.webp';
import history8 from '@/../../public/ourhistory/ourhistory_8.webp';
import history9 from '@/../../public/ourhistory/ourhistory_9.webp';

import TypingText from '@/Components/TypeingText';

export default function OurHistory() {
    const { t  , i18n} = useTranslation()
    const [activeIndex, setActiveIndex] = useState(0);

    const handleActiveIndex = (current: number, next: number) => {
        setActiveIndex(next);
    };
    return (
        <>
            <div className='m-5 py-5 px-8  grid grid-cols-1 '>
                <div className='flex'>

                    <p className="font-sans text-sm lg:text-base font-bold  text-custom-dark-blue  p-4 mb-2  dark:text-white">{t('ourhistory.title')}</p>
                </div>
                <p className='dark:text-white font-bold text-sm lg:text-base p-4 pt-1 font-sans'>
                    {t('ourhistory.subtitle')}
                </p>
                <Carousel
                    beforeChange={handleActiveIndex}
                    dotPosition="top"
                    autoplay
                    autoplaySpeed={20000}>
                    {/* Slide 1 */}
                    <div className="">
                        <div
                            className='grid grid-cols-2'

                        >
                            {/* relative image container */}
                            <div className='relative xs:hidden'>
                                {/* slide image one */}
                                <div className={`h-[340px]  xs:hidden overflow-hidden rounded-e-full ${activeIndex === 0 ? 'animate-faderight' : '0'} duration-300 absolute w-full xs:hi`}
                                    style={{
                                        animationDuration: "1s",
                                        animationDelay: "0.75s"
                                    }}
                                >
                                    <img src={history1} alt="Patient" className="h-96 w-full object-center object-cover -top-4 absolute"

                                    />

                                </div>
                                {/* slide image tow */}
                                <div className={`h-[340px] xs:hidden overflow-hidden rounded-e-full ${activeIndex === 0 ? 'animate-faderight' : '0'} duration-300 absolute w-full`}
                                    style={{
                                        animationDuration: "1s",
                                        animationDelay: "8s"
                                    }}
                                >
                                    <img src={history2} alt="Patient" className="h-96 w-full object-cover "

                                    />

                                </div>


                            </div>

                            <div className={`flex flex-col  gap-6 ps-10 px-4  py-10 items-center duration-300 xs:col-span-2`}>
                                <p
                                 className={`font-bold font-sans lg:text-base text-sm px-0 text-custom-dark-blue lg:px-10 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}  ${activeIndex === 0 ? 'animate-fadeup' : '0'} duration-300 delay-75 dark:text-white `}
                                 >
                                    {t('ourhistory.subtitle_one')}
                                </p>
                                <div className='flex flex-col text-end'>
                                    {activeIndex === 0 &&
                                        <TypingText text={t('ourhistory.content_one')} speed={50}
                                            className='font-bold font-sans text-sm lg:text-base text-start h-[340px] '

                                        />

                                    }

                                </div>


                            </div>
                        </div>
                    </div>

                    {/* Slide 2 */}
                    <div className="">
                        <div
                            className='grid grid-cols-2'

                        >
                            {/* relative image container */}
                            <div className='relative xs:hidden'>
                                {/* slide image four */}

                                <div className={`h-[340px] xs:hidden overflow-hidden rounded-e-full ${activeIndex === 1 ? 'animate-faderight' : '0'} duration-300 absolute w-full`}
                                    style={{
                                        animationDuration: "1s",
                                        animationDelay: "0.75s"
                                    }}
                                >
                                    <img src={history4} alt="Patient" className="h-96 w-full object-cover "

                                    />

                                </div>


                                {/* slide image six */}

                                <div className={`h-[340px] xs:hidden overflow-hidden rounded-e-full ${activeIndex === 1 ? 'animate-faderight' : '0'} duration-300 absolute w-full`}
                                    style={{
                                        animationDuration: "1s",
                                        animationDelay: "9s"
                                    }}
                                >
                                    <img src={history3} alt="Patient" className="h-96 w-full object-cover "

                                    />

                                </div>

                            </div>


                            <div className={`flex flex-col  gap-6 ps-10 px-4 0033A0 py-10 items-center duration-300 xs:col-span-2`}>
                                <p
                                 className={`font-bold font-sans lg:text-base text-sm px-0 text-custom-dark-blue lg:px-10 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}  ${activeIndex === 0 ? 'animate-fadeup' : '0'} duration-300 delay-75 dark:text-white `}
                                 >
                                    {t('ourhistory.subtitle_tow')}
                                </p>
                                <div className='flex flex-col text-end'>
                                    {activeIndex === 1 &&
                                        <TypingText text={t('ourhistory.content_tow')} speed={50}
                                            className='font-bold font-sans text-sm lg:text-base text-start h-[340px]'

                                        />

                                    }

                                </div>

                            </div>
                        </div>
                    </div>
                    {/* Slide 3 */}
                    <div className="">
                        <div
                            className='grid grid-cols-2'

                        >

                            {/* relative image container */}
                            <div className='relative xs:hidden'>
                                {/* slide image one */}
                                <div className={`h-[340px] xs:hidden overflow-hidden rounded-e-full ${activeIndex === 2 ? 'animate-faderight' : '0'} duration-300 absolute w-full`}
                                    style={{
                                        animationDuration: "1s",
                                        animationDelay: "0.75s"
                                    }}
                                >
                                    <img src={history6} alt="Patient" className="h-96 w-full object-cover "

                                    />

                                </div>

                                {/* slide image one */}
                                <div className={`h-[340px] xs:hidden overflow-hidden rounded-e-full ${activeIndex === 2 ? 'animate-faderight' : '0'} duration-300 absolute w-full`}
                                    style={{
                                        animationDuration: "1s",
                                        animationDelay: "8s"
                                    }}
                                >
                                    <img src={history7} alt="Patient" className="h-96 w-full object-cover "

                                    />

                                </div>

                            </div>

                            <div className={`flex flex-col  gap-6 ps-10 px-4 0033A0 py-10 items-center duration-300 xs:col-span-2`}>
                                <p
                                className={`font-bold font-sans lg:text-base text-sm px-0 text-custom-dark-blue lg:px-10 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}  ${activeIndex === 0 ? 'animate-fadeup' : '0'} duration-300 delay-75 dark:text-white `}
                                >
                                    {t('ourhistory.subtitle_three')}
                                </p>
                                <div className='flex flex-col text-end'>
                                    {activeIndex === 2 &&
                                        <TypingText text={t('ourhistory.content_three')} speed={50}
                                            className='font-bold font-sans text-sm lg:text-base text-start h-[340px]'

                                        />

                                    }

                                </div>

                            </div>
                        </div>
                    </div>


                    {/* Slide 4 */}
                    <div className="">
                        <div
                            className='grid grid-cols-2'

                        >
                            {/* relative image container */}
                            <div className='relative xs:hidden'>
                                {/* slide image one */}
                                <div className={`h-[340px] xs:hidden overflow-hidden rounded-e-full ${activeIndex === 3 ? 'animate-faderight' : '0'} duration-300 absolute w-full`}
                                    style={{
                                        animationDuration: "1s",
                                        animationDelay: "0.75s"
                                    }}
                                >
                                    <img src={history8} alt="Patient" className="h-96 w-full object-cover "

                                    />

                                </div>

                                {/* slide image one */}
                                <div className={`h-[340px] xs:hidden overflow-hidden rounded-e-full ${activeIndex === 3 ? 'animate-faderight' : '0'} duration-300 absolute w-full`}
                                    style={{
                                        animationDuration: "1s",
                                        animationDelay: "3s"
                                    }}
                                >
                                    <img src={history9} alt="Patient" className="h-96 w-full object-cover "

                                    />

                                </div>

                            </div>


                            <div className={`flex flex-col  gap-6 ps-10 px-4 0033A0 py-10 items-center duration-300 xs:col-span-2`}>
                                <p
                                className={`font-bold font-sans lg:text-base text-sm px-0 text-custom-dark-blue lg:px-10 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}  ${activeIndex === 0 ? 'animate-fadeup' : '0'} duration-300 delay-75 dark:text-white `}
                                >
                                    {t('ourhistory.subtitle_four')}
                                </p>

                                <div className='flex flex-col text-end'>
                                    {activeIndex === 3 &&
                                        <TypingText text={t('ourhistory.content_four')} speed={50}
                                            className='font-bold font-sans text-sm lg:text-base text-start h-[340px]'

                                        />

                                    }

                                </div>


                            </div>
                        </div>
                    </div>


                </Carousel>
            </div>

        </>
    );
}